import { render, staticRenderFns } from "./mail-log.vue?vue&type=template&id=5e96f9cf&"
import script from "./mail-log.vue?vue&type=script&lang=js&"
export * from "./mail-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports